import { LayoutState, initialLayoutState } from 'layout/LayoutState';
import LayoutRendererState, {
    initialLayoutRendererState,
} from 'layoutRenderer/LayoutRendererState';
import { LoginState, initialLoginState } from 'login/store/LoginState';
import NotificationState, {
    initialNotificationState,
} from 'notification/NotificationState';
import { AppState, initialAppState } from 'app/store/AppState';
import {
    PortfolioState,
    initialPortfolioState,
} from 'portfolio/PortfolioState';
import {
    RequestProgressState,
    initialRequestsProgressState,
} from 'requestProgress/store/RequestProgressState';

import {
    PositionEntryState,
    initialPositionEntryState,
} from 'positionEntry/store/PositionEntryState';
import WidgetsState, { initialWidgetsState } from 'widgets/store/WidgetsState';
import {
    EmbeddedApiState,
    initialEmbeddedApiState,
} from 'embedded/api/store/EmbeddedApiState';
import {
    initialStreamState,
    StreamsState,
} from 'streamsState/store/StreamsState';
import {
    LayoutListsState,
    initialLayoutListsState,
} from 'layout/store/layoutsListSlice';
import {
    EmbeddedAppState,
    initialEmbeddedAppState,
} from 'embedded/store/EmbeddedAppState';
import {
    MarketDataState,
    initialMarketDataState,
} from 'marketData/store/MarketDataState';
import {
    BloombergState,
    initialBloombergState,
} from 'app/glue/bloomberg/store/bloombergSlice';
import {
    initialSymbolInfoState,
    SymbolInfoState,
} from 'symbols/symbolInfo/symbolInfoSlice';
import {
    initialUserPreferencesState,
    UserPreferencesState,
} from 'userPreferences/userPreferencesSlice';
import {
    initialSymbolStaticData,
    SymbolStaticDataState,
} from 'symbols/store/symbolStaticDataSlice';
import { IndexMappingsState } from 'symbols/indexMappings/store/IndexMappingsState';
import {
    initialNewportAppState,
    NewportAppState,
} from 'newport/store/newportAppSlice';
import {
    initialTradeDatesState,
    TradeDatesState,
} from 'tradeDates/store/tradeDatesSlice.ts';
import { ImpactModelState } from 'impactModel/impact-model-slice.ts';
import {
    DarkVenueMappingState,
    initialDarkVenueMappingsState,
} from 'widgets/darkVenueHeatmap/venueMappings/darkVenueMappingsSlice.ts';

export default interface State {
    app: AppState;
    bloomberg: BloombergState;
    darkVenueMappings: DarkVenueMappingState;
    embeddedApi: EmbeddedApiState;
    embeddedApp: EmbeddedAppState;
    impactModel: ImpactModelState;
    indexMappings: IndexMappingsState;
    layout: LayoutState;
    layoutList: LayoutListsState;
    layoutRenderer: LayoutRendererState;
    login: LoginState;
    marketData: MarketDataState;
    newportApp: NewportAppState;
    notification: NotificationState;
    portfolio: PortfolioState;
    positionEntry: PositionEntryState;
    tradeDates: TradeDatesState;
    userPreferences: UserPreferencesState;
    requestProgress: RequestProgressState;
    streams: StreamsState;
    symbolInfos: SymbolInfoState;
    symbolStaticData: SymbolStaticDataState;
    widgets: WidgetsState;
}

export const initialState: State = {
    app: initialAppState,
    bloomberg: initialBloombergState,
    darkVenueMappings: initialDarkVenueMappingsState,
    embeddedApi: initialEmbeddedApiState,
    embeddedApp: initialEmbeddedAppState,
    impactModel: {},
    indexMappings: {},
    layout: initialLayoutState,
    layoutList: initialLayoutListsState,
    layoutRenderer: initialLayoutRendererState,
    login: initialLoginState,
    marketData: initialMarketDataState,
    newportApp: initialNewportAppState,
    notification: initialNotificationState,
    positionEntry: initialPositionEntryState,
    portfolio: initialPortfolioState,
    tradeDates: initialTradeDatesState,
    userPreferences: initialUserPreferencesState,
    requestProgress: initialRequestsProgressState,
    streams: initialStreamState,
    symbolInfos: initialSymbolInfoState,
    symbolStaticData: initialSymbolStaticData,
    widgets: initialWidgetsState,
};
